import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import "./filter-table.scss";
import FormItemDropdown from "../../../../components/form-dropdown/FormItemDropdown";

type FormFilterProps = {
  handleCloseFilter: () => void;
  tab: string;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: () => void;
  dataOptions?: any;
  isScheduleByTeacherCourse?: boolean;
  enrollClassData?: any;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  onFinish,
  form,
  showFilter,
  clearFilter,
  tab,
  isScheduleByTeacherCourse,
  enrollClassData
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const registrationStatusOptions = [
    {
      code: 2,
      name: t("Nâng cao", "Nâng cao")
    },
    {
      code: 1,
      name: t("Cơ bản", "Cơ bản")
    },
    {
      code: 3,
      name: t("Học thử", "Học thử")
    },
    {
      code: 0,
      name: t("Đã xóa", "Đã xóa")
    },
  ]

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={8}>
            {
              tab === "0" ? (
              <Col
                xl={{ span: 4 }}
                md={{ span: 4 }}
                sm={{ span: 4 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Trạng thái", "Trạng thái")}</Typography.Title>
                <Form.Item name="registrationStatus">
                  <FormItemDropdown placeholder={t("Chọn trạng thái", "Chọn trạng thái")} options={registrationStatusOptions} modeDropdown="multiple" allowClear />
                </Form.Item>
              </Col>
            ) : null}
            {isScheduleByTeacherCourse ? (
              <Col
                xl={{ span: 4 }}
                md={{ span: 4 }}
                sm={{ span: 4 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Lớp ghi danh", "Lớp ghi danh")}</Typography.Title>

                <Form.Item name="enrollClass">
                  <FormItemDropdown options={enrollClassData} placeholder={t("Chọn lớp ghi danh", "Chọn lớp ghi danh")}/>
                </Form.Item>
              </Col>
            ) : null}
            <Col
              xl={{ span: 4 }}
              md={{ span: 4 }}
              sm={{ span: 4 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Ngày ghi danh", "Ngày ghi danh")}</Typography.Title>

              <Form.Item name="enrollmentDate">
                <RangePicker
                  placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                  format="YYYY-MM-DD"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 4 }}
              sm={{ span: 4 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Ngày bắt đầu", "Ngày bắt đầu")}</Typography.Title>
              <Form.Item name="startDate">
                <RangePicker
                  placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                  format="YYYY-MM-DD"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 4 }}
              sm={{ span: 4 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Ngày kết thúc", "Ngày kết thúc")}</Typography.Title>
              <Form.Item name="endDate">
                <RangePicker
                  placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                  format="YYYY-MM-DD"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {tab === "3" ? (
              <Col
                xl={{ span: 4 }}
                md={{ span: 4 }}
                sm={{ span: 4 }}
                xs={{ span: 24 }}
              >
                <Typography.Title level={5}>{t("Ngày chuyển đổi", "Ngày chuyển đổi")}</Typography.Title>
                <Form.Item name="conversionDate">
                  <RangePicker
                    placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                    format="YYYY-MM-DD"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            ) : (
              <></>
            )}
            <Col
              xl={{ span: 4 }}
              md={{ span: 4 }}
              sm={{ span: 4 }}
              xs={{ span: 24 }}
              style={{ alignContent: "end" }}
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary search-btn"
                  htmlType="submit"
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
